import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        aboutUs: 'About Us',
        services: 'Services',
        portfolio: 'Portfolio',
        salesLeadsPro: 'Sales Leads Pro',
        contact: 'Contact'
      },
      hero: {
        tagline: 'for ambitious businesses',
        title: 'Scale your business.',
        titleLine2: 'Not your costs.',
        description: 'From AI-powered SaaS solutions to stunning websites—we deliver custom digital products that drive growth, built with cutting-edge technology at a fraction of traditional costs.',
        ctaExplore: 'Explore SaaS Solutions',
        ctaServices: 'See All Services',
        badge1: 'AI-Powered Solutions',
        badge2: 'Custom Development',
        badge3: 'Global Services'
      },
      stats: {
        label1: 'Professional excellence',
        label2: 'Growing portfolio',
        mba: 'MBA',
        mbaLabel: 'in Business Development',
        successRate: '100%',
        successLabel: 'Customer Success Rate',
        delivery: '2 weeks',
        deliveryLabel: 'Avg. Delivery Time'
      },
      services: {
        tagline: 'what we offer',
        title: 'Our Services',
        description: 'Comprehensive digital solutions tailored to your business needs',
        aiWebsite: 'AI Website Building',
        aiWebsiteDesc: 'Professional landing pages and fullstack applications built with Emergent AI—agency quality at a fraction of the cost.',
        feature1: 'Landing Pages from €350',
        feature2: 'Fullstack Apps from €950',
        feature3: '2 Rounds of Revisions',
        imageTitle: 'Built with Modern Technology',
        imageDesc: 'Every website is crafted using cutting-edge AI technology and best practices for performance, security, and scalability.',
        process: 'Business Process Analysis',
        processDesc: 'Deep-dive analysis of your operations to identify inefficiencies and opportunities for automation and improvement.',
        saas: 'Customized SaaS Solutions',
        saasDesc: 'Bespoke software-as-a-service platforms designed specifically for your business model and customer needs.'
      },
      portfolio: {
        tagline: 'our work',
        title: 'Portfolio',
        description: 'Showcasing our recent AI-powered website projects',
        viewLive: 'View Live Site',
        case1Title: 'Fullstack App for Financial Reconciliation',
        case2Title: 'Fullstack App for Quality Management System',
        case3Title: 'Landing Page for Logardt Ekonomiresurs',
        case4Title: 'Landing Page for Redoc AML & KYC',
        case5Title: 'Landing Page for Orchestra Administration Platform',
        case6Title: 'Fullstack App for Vacation Property Rental Platform',
        case7Title: 'Landing Page for Author website'
      },
      howItWorks: {
        tagline: 'our work process',
        title: 'How we work with you.',
        step1Num: '01',
        step1Title: 'Discovery & Planning',
        step1Desc: 'We understand your business, goals, and requirements. Define scope, timeline, and deliverables.',
        step2Num: '02',
        step2Title: 'Design & Development',
        step2Desc: 'Our team builds your solution using the latest AI and development tools. Regular updates and feedback loops.',
        step3Num: '03',
        step3Title: 'Launch & Support',
        step3Desc: 'Deploy your project with full testing. Ongoing support and iterations based on your needs.'
      },
      contact: {
        tagline: 'get in touch',
        title: "Let's build something great together",
        description: "Have a project in mind? We'd love to hear about it. Send us a message and we'll get back to you as soon as possible.",
        nameLabel: 'Your Name',
        namePlaceholder: 'John Doe',
        emailLabel: 'Email Address',
        emailPlaceholder: 'john@example.com',
        inquiryLabel: 'Inquiry Type',
        messageLabel: 'Your Message',
        messagePlaceholder: 'Tell us about your project...',
        submitButton: 'Send Message',
        submitting: 'Sending...',
        successMessage: 'Thank you! Your message has been sent successfully.',
        errorMessage: 'Sorry, something went wrong. Please try again.',
        inquiryTypes: {
          aiLanding: 'AI Landing Page',
          aiFullstack: 'AI Website Building (Fullstack App)',
          businessProcess: 'Business Process Analysis',
          businessDev: 'Business Development Case Request',
          customSaas: 'Customized SaaS Solutions',
          general: 'General Request / Quote',
          salesLeads: 'SaaS Sales Leads Pro Quote'
        }
      },
      footer: {
        tagline: 'Logardt Group KB',
        description: 'Delivering AI-powered digital solutions that scale your business.',
        servicesTitle: 'Services',
        companyTitle: 'Company',
        legalTitle: 'Legal',
        aboutUs: 'About Us',
        portfolio: 'Portfolio',
        contact: 'Contact',
        terms: 'Terms of Service',
        privacy: 'Privacy Policy',
        cookies: 'Cookies Policy',
        copyright: '© 2025 Logardt Group KB. All rights reserved.',
        vatNumber: 'VAT Number',
        location: 'Täby, Sweden'
      }
    }
  },
  sv: {
    translation: {
      nav: {
        home: 'Hem',
        aboutUs: 'Om Oss',
        services: 'Tjänster',
        portfolio: 'Portfolio',
        salesLeadsPro: 'Sales Leads Pro',
        contact: 'Kontakt'
      },
      hero: {
        tagline: 'för ambitiösa företag',
        title: 'Skala upp ditt företag.',
        titleLine2: 'Inte dina kostnader.',
        description: 'Från AI-drivna SaaS-lösningar till fantastiska webbplatser—vi levererar skräddarsydda digitala produkter som driver tillväxt, byggda med banbrytande teknik till en bråkdel av traditionella kostnader.',
        ctaExplore: 'Utforska SaaS-lösningar',
        ctaServices: 'Se alla tjänster',
        badge1: 'AI-drivna lösningar',
        badge2: 'Anpassad utveckling',
        badge3: 'Globala tjänster'
      },
      stats: {
        label1: 'Professionell excellens',
        label2: 'Växande portfolio',
        mba: 'MBA',
        mbaLabel: 'i Affärsutveckling',
        successRate: '100%',
        successLabel: 'Kundnöjdhet',
        delivery: '2 veckor',
        deliveryLabel: 'Genomsnittlig leveranstid'
      },
      services: {
        tagline: 'vad vi erbjuder',
        title: 'Våra tjänster',
        description: 'Omfattande digitala lösningar skräddarsydda för dina affärsbehov',
        aiWebsite: 'AI hemsidor',
        aiWebsiteDesc: 'Professionella landningssidor och fullstack-applikationer byggda med Emergent AI—byråkvalitet till en bråkdel av kostnaden.',
        feature1: 'Landningssidor från €350',
        feature2: 'Fullstack-appar från €950',
        feature3: '2 omgångar av revidering',
        imageTitle: 'Byggd med modern teknik',
        imageDesc: 'Varje webbplats skapas med banbrytande AI-teknik och bästa praxis för prestanda, säkerhet och skalbarhet.',
        process: 'Affärsprocessanalys',
        processDesc: 'Djupgående analys av dina operationer för att identifiera ineffektivitet och möjligheter för automation och förbättring.',
        saas: 'Anpassade SaaS-lösningar',
        saasDesc: 'Skräddarsydda programvara-som-en-tjänst-plattformar designade specifikt för din affärsmodell och kundbehov.'
      },
      portfolio: {
        tagline: 'vårt arbete',
        title: 'Portfolio',
        description: 'Visar våra senaste AI-drivna webbplatsprojekt',
        viewLive: 'Visa live-sida',
        case1Title: 'Fullstack-app för finansiell avstämning',
        case2Title: 'Fullstack-app för kvalitetsledningssystem',
        case3Title: 'Målsida för Logardt Ekonomiresurs',
        case4Title: 'Målsida för Redoc AML & KYC',
        case5Title: 'Målsida för orkesteradministrationsplattform',
        case6Title: 'Fullstack-app för semesteruthyrningsplattform',
        case7Title: 'Målsida för författarwebbplats'
      },
      howItWorks: {
        tagline: 'vår arbetsprocess',
        title: 'Hur vi arbetar med dig.',
        step1Num: '01',
        step1Title: 'Upptäckt & Planering',
        step1Desc: 'Vi förstår ditt företag, mål och krav. Definiera omfattning, tidslinje och leveranser.',
        step2Num: '02',
        step2Title: 'Design & Utveckling',
        step2Desc: 'Vårt team bygger din lösning med de senaste AI- och utvecklingsverktygen. Regelbundna uppdateringar och feedbackloopar.',
        step3Num: '03',
        step3Title: 'Lansering & Support',
        step3Desc: 'Distribuera ditt projekt med fullständig testning. Pågående support och iterationer baserat på dina behov.'
      },
      contact: {
        tagline: 'kontakta oss',
        title: 'Låt oss bygga något fantastiskt tillsammans',
        description: 'Har du ett projekt i åtanke? Vi skulle gärna höra om det. Skicka oss ett meddelande så återkommer vi så snart som möjligt.',
        nameLabel: 'Ditt namn',
        namePlaceholder: 'Erik Andersson',
        emailLabel: 'E-postadress',
        emailPlaceholder: 'erik@exempel.se',
        inquiryLabel: 'Typ av förfrågan',
        messageLabel: 'Ditt meddelande',
        messagePlaceholder: 'Berätta om ditt projekt...',
        submitButton: 'Skicka meddelande',
        submitting: 'Skickar...',
        successMessage: 'Tack! Ditt meddelande har skickats.',
        errorMessage: 'Något gick fel. Vänligen försök igen.',
        inquiryTypes: {
          aiLanding: 'AI-målsida',
          aiFullstack: 'AI-webbsidebyggande (Fullstack-app)',
          businessProcess: 'Affärsprocessanalys',
          businessDev: 'Affärsutvecklingsförfrågan',
          customSaas: 'Anpassade SaaS-lösningar',
          general: 'Allmän förfrågan / Offert',
          salesLeads: 'SaaS Sales Leads Pro Offert'
        }
      },
      footer: {
        tagline: 'Logardt Group KB',
        description: 'Levererar AI-drivna digitala lösningar som skalar ditt företag.',
        servicesTitle: 'Tjänster',
        companyTitle: 'Företag',
        legalTitle: 'Juridiskt',
        aboutUs: 'Om oss',
        portfolio: 'Portfolio',
        contact: 'Kontakt',
        terms: 'Användarvillkor',
        privacy: 'Integritetspolicy',
        cookies: 'Cookie-policy',
        copyright: '© 2025 Logardt Group KB. Alla rättigheter förbehållna.',
        vatNumber: 'Org.nr',
        location: 'Täby, Sverige'
      }
    }
  },
  no: {
    translation: {
      nav: {
        home: 'Hjem',
        aboutUs: 'Om Oss',
        services: 'Tjenester',
        portfolio: 'Portfolio',
        salesLeadsPro: 'Sales Leads Pro',
        contact: 'Kontakt'
      },
      hero: {
        tagline: 'for ambisiøse bedrifter',
        title: 'Skaler virksomheten din.',
        titleLine2: 'Ikke kostnadene.',
        description: 'Fra AI-drevne SaaS-løsninger til fantastiske nettsider—vi leverer skreddersydde digitale produkter som driver vekst, bygget med banebrytende teknologi til en brøkdel av tradisjonelle kostnader.',
        ctaExplore: 'Utforsk SaaS-løsninger',
        ctaServices: 'Se alle tjenester',
        badge1: 'AI-drevne løsninger',
        badge2: 'Tilpasset utvikling',
        badge3: 'Globale tjenester'
      },
      stats: {
        label1: 'Profesjonell ekspertise',
        label2: 'Voksende portfolio',
        mba: 'MBA',
        mbaLabel: 'i Forretningsutvikling',
        successRate: '100%',
        successLabel: 'Kundetilfredshet',
        delivery: '2 uker',
        deliveryLabel: 'Gj.snittlig leveringstid'
      },
      services: {
        tagline: 'hva vi tilbyr',
        title: 'Våre tjenester',
        description: 'Omfattende digitale løsninger skreddersydd til dine forretningsbehov',
        aiWebsite: 'AI-nettstedsbygging',
        aiWebsiteDesc: 'Profesjonelle landingssider og fullstack-applikasjoner bygget med Emergent AI—byråkvalitet til en brøkdel av kostnaden.',
        feature1: 'Landingssider fra €350',
        feature2: 'Fullstack-apper fra €950',
        feature3: '2 runder med revisjoner',
        imageTitle: 'Bygget med moderne teknologi',
        imageDesc: 'Hvert nettsted er laget med banebrytende AI-teknologi og beste praksis for ytelse, sikkerhet og skalerbarhet.',
        process: 'Forretningsprosessanalyse',
        processDesc: 'Dyptgående analyse av dine operasjoner for å identifisere ineffektivitet og muligheter for automatisering og forbedring.',
        saas: 'Tilpassede SaaS-løsninger',
        saasDesc: 'Skreddersydde programvare-som-en-tjeneste-plattformer designet spesifikt for din forretningsmodell og kundebehov.'
      },
      portfolio: {
        tagline: 'vårt arbeid',
        title: 'Portfolio',
        description: 'Viser våre nyeste AI-drevne nettstedsprosjekter',
        viewLive: 'Vis live-side',
        case1Title: 'Fullstack-app for finansiell avstemming',
        case2Title: 'Fullstack-app for kvalitetsstyringssystem',
        case3Title: 'Landingsside for Logardt Ekonomiresurs',
        case4Title: 'Landingsside for Redoc AML & KYC',
        case5Title: 'Landingsside for orkesteradministrasjonsplattform',
        case6Title: 'Fullstack-app for ferieutleieplattform',
        case7Title: 'Landingsside for forfatternettsted'
      },
      howItWorks: {
        tagline: 'vår arbeidsprosess',
        title: 'Hvordan vi arbeider med deg.',
        step1Num: '01',
        step1Title: 'Oppdagelse & Planlegging',
        step1Desc: 'Vi forstår din bedrift, mål og krav. Definer omfang, tidslinje og leveranser.',
        step2Num: '02',
        step2Title: 'Design & Utvikling',
        step2Desc: 'Vårt team bygger din løsning med de nyeste AI- og utviklingsverktøyene. Regelmessige oppdateringer og tilbakemeldingssløyfer.',
        step3Num: '03',
        step3Title: 'Lansering & Support',
        step3Desc: 'Distribuer prosjektet ditt med full testing. Løpende support og iterasjoner basert på dine behov.'
      },
      contact: {
        tagline: 'ta kontakt',
        title: 'La oss bygge noe fantastisk sammen',
        description: 'Har du et prosjekt i tankene? Vi vil gjerne høre om det. Send oss en melding, så tar vi kontakt så snart som mulig.',
        nameLabel: 'Ditt navn',
        namePlaceholder: 'Ola Nordmann',
        emailLabel: 'E-postadresse',
        emailPlaceholder: 'ola@eksempel.no',
        inquiryLabel: 'Type henvendelse',
        messageLabel: 'Din melding',
        messagePlaceholder: 'Fortell oss om prosjektet ditt...',
        submitButton: 'Send melding',
        submitting: 'Sender...',
        successMessage: 'Takk! Din melding er sendt.',
        errorMessage: 'Noe gikk galt. Vennligst prøv igjen.',
        inquiryTypes: {
          aiLanding: 'AI-landingsside',
          aiFullstack: 'AI-nettstedsbygging (Fullstack-app)',
          businessProcess: 'Forretningsprosessanalyse',
          businessDev: 'Forretningsutviklingsforespørsel',
          customSaas: 'Tilpassede SaaS-løsninger',
          general: 'Generell henvendelse / Tilbud',
          salesLeads: 'SaaS Sales Leads Pro Tilbud'
        }
      },
      footer: {
        tagline: 'Logardt Group KB',
        description: 'Leverer AI-drevne digitale løsninger som skalerer virksomheten din.',
        servicesTitle: 'Tjenester',
        companyTitle: 'Selskap',
        legalTitle: 'Juridisk',
        aboutUs: 'Om oss',
        portfolio: 'Portfolio',
        contact: 'Kontakt',
        terms: 'Brukervilkår',
        privacy: 'Personvernerklæring',
        cookies: 'Cookie-policy',
        copyright: '© 2025 Logardt Group KB. Alle rettigheter reservert.',
        vatNumber: 'Org.nr',
        location: 'Täby, Sverige'
      }
    }
  },
  da: {
    translation: {
      nav: {
        home: 'Hjem',
        aboutUs: 'Om Os',
        services: 'Tjenester',
        portfolio: 'Portfolio',
        salesLeadsPro: 'Sales Leads Pro',
        contact: 'Kontakt'
      },
      hero: {
        tagline: 'for ambitiøse virksomheder',
        title: 'Skaler din virksomhed.',
        titleLine2: 'Ikke dine omkostninger.',
        description: 'Fra AI-drevne SaaS-løsninger til fantastiske hjemmesider—vi leverer skræddersyede digitale produkter, der driver vækst, bygget med banebrydende teknologi til en brøkdel af traditionelle omkostninger.',
        ctaExplore: 'Udforsk SaaS-løsninger',
        ctaServices: 'Se alle tjenester',
        badge1: 'AI-drevne løsninger',
        badge2: 'Tilpasset udvikling',
        badge3: 'Globale tjenester'
      },
      stats: {
        label1: 'Professionel ekspertise',
        label2: 'Voksende portfolio',
        mba: 'MBA',
        mbaLabel: 'i Forretningsudvikling',
        successRate: '100%',
        successLabel: 'Kundetilfredshed',
        delivery: '2 uger',
        deliveryLabel: 'Gns. leveringstid'
      },
      services: {
        tagline: 'hvad vi tilbyder',
        title: 'Vores tjenester',
        description: 'Omfattende digitale løsninger skræddersyet til dine forretningsbehov',
        aiWebsite: 'AI-webstedsudvikling',
        aiWebsiteDesc: 'Professionelle landingssider og fullstack-applikationer bygget med Emergent AI—bureaukvalitet til en brøkdel af omkostningerne.',
        feature1: 'Landingssider fra €350',
        feature2: 'Fullstack-apps fra €950',
        feature3: '2 runder med revisioner',
        imageTitle: 'Bygget med moderne teknologi',
        imageDesc: 'Hvert websted er lavet med banebrydende AI-teknologi og bedste praksis for ydeevne, sikkerhed og skalerbarhed.',
        process: 'Forretningsprocesanalyse',
        processDesc: 'Dybdegående analyse af dine operationer for at identificere ineffektivitet og muligheder for automatisering og forbedring.',
        saas: 'Tilpassede SaaS-løsninger',
        saasDesc: 'Skræddersyede software-as-a-service-platforme designet specifikt til din forretningsmodel og kundebehov.'
      },
      portfolio: {
        tagline: 'vores arbejde',
        title: 'Portfolio',
        description: 'Viser vores nyeste AI-drevne webstedsprojekter',
        viewLive: 'Se live-side',
        case1Title: 'Fullstack-app til finansiel afstemning',
        case2Title: 'Fullstack-app til kvalitetsstyringssystem',
        case3Title: 'Landingsside for Logardt Ekonomiresurs',
        case4Title: 'Landingsside for Redoc AML & KYC',
        case5Title: 'Landingsside til orkesteradministrationsplatform',
        case6Title: 'Fullstack-app til ferieudlejningsplatform',
        case7Title: 'Landingsside til forfatterwebsted'
      },
      howItWorks: {
        tagline: 'vores arbejdsproces',
        title: 'Hvordan vi arbejder med dig.',
        step1Num: '01',
        step1Title: 'Opdagelse & Planlægning',
        step1Desc: 'Vi forstår din virksomhed, mål og krav. Definer omfang, tidslinje og leverancer.',
        step2Num: '02',
        step2Title: 'Design & Udvikling',
        step2Desc: 'Vores team bygger din løsning med de nyeste AI- og udviklingsværktøjer. Regelmæssige opdateringer og feedback-loops.',
        step3Num: '03',
        step3Title: 'Lancering & Support',
        step3Desc: 'Implementer dit projekt med fuld test. Løbende support og iterationer baseret på dine behov.'
      },
      contact: {
        tagline: 'kontakt os',
        title: 'Lad os bygge noget fantastisk sammen',
        description: 'Har du et projekt i tankerne? Vi vil gerne høre om det. Send os en besked, så vender vi tilbage hurtigst muligt.',
        nameLabel: 'Dit navn',
        namePlaceholder: 'Anders Jensen',
        emailLabel: 'E-mailadresse',
        emailPlaceholder: 'anders@eksempel.dk',
        inquiryLabel: 'Type henvendelse',
        messageLabel: 'Din besked',
        messagePlaceholder: 'Fortæl os om dit projekt...',
        submitButton: 'Send besked',
        submitting: 'Sender...',
        successMessage: 'Tak! Din besked er sendt.',
        errorMessage: 'Noget gik galt. Prøv venligst igen.',
        inquiryTypes: {
          aiLanding: 'AI-landingsside',
          aiFullstack: 'AI-webstedsudvikling (Fullstack-app)',
          businessProcess: 'Forretningsprocesanalyse',
          businessDev: 'Forretningsudviklingsforespørgsel',
          customSaas: 'Tilpassede SaaS-løsninger',
          general: 'Generel henvendelse / Tilbud',
          salesLeads: 'SaaS Sales Leads Pro Tilbud'
        }
      },
      footer: {
        tagline: 'Logardt Group KB',
        description: 'Leverer AI-drevne digitale løsninger, der skalerer din virksomhed.',
        servicesTitle: 'Tjenester',
        companyTitle: 'Firma',
        legalTitle: 'Juridisk',
        aboutUs: 'Om os',
        portfolio: 'Portfolio',
        contact: 'Kontakt',
        terms: 'Servicevilkår',
        privacy: 'Privatlivspolitik',
        cookies: 'Cookie-politik',
        copyright: '© 2025 Logardt Group KB. Alle rettigheder forbeholdes.',
        vatNumber: 'CVR-nr',
        location: 'Täby, Sverige'
      }
    }
  }
};

// Add Finnish, Italian, French, German, Greek, Spanish
resources.fi = {
  translation: {
    nav: {
      home: 'Etusivu',
      aboutUs: 'Tietoa Meistä',
      services: 'Palvelut',
      portfolio: 'Portfolio',
      salesLeadsPro: 'Sales Leads Pro',
      contact: 'Ota Yhteyttä'
    },
    hero: {
      tagline: 'kunnianhimoisille yrityksille',
      title: 'Skaalaa liiketoimintaasi.',
      titleLine2: 'Ei kustannuksiasi.',
      description: 'AI-ohjattuista SaaS-ratkaisuista upeisiin verkkosivustoihin—toimitamme räätälöityjä digitaalisia tuotteita, jotka edistävät kasvua, rakennettuina huipputeknologialla murto-osalla perinteisistä kustannuksista.',
      ctaExplore: 'Tutustu SaaS-ratkaisuihin',
      ctaServices: 'Katso kaikki palvelut',
      badge1: 'AI-ohjatut ratkaisut',
      badge2: 'Räätälöity kehitys',
      badge3: 'Maailmanlaajuiset palvelut'
    },
    stats: {
      label1: 'Ammatillinen huippuosaaminen',
      label2: 'Kasvava portfolio',
      mba: 'MBA',
      mbaLabel: 'Liiketoiminnan Kehityksessä',
      successRate: '100%',
      successLabel: 'Asiakastyytyväisyys',
      delivery: '2 viikkoa',
      deliveryLabel: 'Keskimääräinen toimitusaika'
    },
    services: {
      tagline: 'mitä tarjoamme',
      title: 'Palvelumme',
      description: 'Kattavat digitaaliset ratkaisut räätälöitynä liiketoimintatarpeisiisi',
      aiWebsite: 'AI-verkkosivuston rakentaminen',
      aiWebsiteDesc: 'Ammattimaiset laskeutumissivut ja fullstack-sovellukset, jotka on rakennettu Emergent AI:lla—toimiston laatua murto-osalla kustannuksista.',
      feature1: 'Laskeutumissivut alkaen €350',
      feature2: 'Fullstack-sovellukset alkaen €950',
      feature3: '2 kierrosta tarkistuksia',
      imageTitle: 'Rakennettu modernilla teknologialla',
      imageDesc: 'Jokainen verkkosivusto on valmistettu huipputeknologialla ja parhailla käytännöillä suorituskyvyn, turvallisuuden ja skaalautuvuuden osalta.',
      process: 'Liiketoimintaprosessianalyysi',
      processDesc: 'Syvällinen analyysi toiminnastasi tehottomuuksien ja automaation ja parantamisen mahdollisuuksien tunnistamiseksi.',
      saas: 'Räätälöidyt SaaS-ratkaisut',
      saasDesc: 'Räätälöidyt ohjelmisto-palveluna-alustat, jotka on suunniteltu erityisesti liiketoimintamalliasi ja asiakkaidesi tarpeita varten.'
    },
    portfolio: {
      tagline: 'työmme',
      title: 'Portfolio',
      description: 'Esittelyssä uusimmat AI-ohjatut verkkosivustoprojektimme',
      viewLive: 'Katso live-sivu',
      case1Title: 'Fullstack-sovellus taloudelliseen täsmäytykseen',
      case2Title: 'Fullstack-sovellus laatujärjestelmään',
      case3Title: 'Laskeutumissivu Logardt Ekonomiresursille',
      case4Title: 'Laskeutumissivu Redoc AML & KYC:lle',
      case5Title: 'Laskeutumissivu orkesterinhallinta-alustalle',
      case6Title: 'Fullstack-sovellus lomavuokrausalustalle',
      case7Title: 'Laskeutumissivu kirjailijan verkkosivustolle'
    },
    howItWorks: {
      tagline: 'työskentelyprosessimme',
      title: 'Kuinka työskentelemme kanssasi.',
      step1Num: '01',
      step1Title: 'Kartoitus & Suunnittelu',
      step1Desc: 'Ymmärrämme yrityksesi, tavoitteesi ja vaatimuksesi. Määritä laajuus, aikataulu ja toimitukset.',
      step2Num: '02',
      step2Title: 'Suunnittelu & Kehitys',
      step2Desc: 'Tiimimme rakentaa ratkaisusi uusimmilla AI- ja kehitystyökaluilla. Säännölliset päivitykset ja palautesilmukat.',
      step3Num: '03',
      step3Title: 'Lanseeraus & Tuki',
      step3Desc: 'Julkaise projektisi täydellä testauksella. Jatkuva tuki ja iteraatiot tarpeidesi mukaan.'
    },
    contact: {
      tagline: 'ota yhteyttä',
      title: 'Rakennetaan yhdessä jotain mahtavaa',
      description: 'Onko sinulla projekti mielessä? Haluamme kuulla siitä. Lähetä meille viesti, niin palaamme asiaan mahdollisimman pian.',
      nameLabel: 'Nimesi',
      namePlaceholder: 'Matti Meikäläinen',
      emailLabel: 'Sähköpostiosoite',
      emailPlaceholder: 'matti@esimerkki.fi',
      inquiryLabel: 'Kyselytyyppi',
      messageLabel: 'Viestisi',
      messagePlaceholder: 'Kerro meille projektistasi...',
      submitButton: 'Lähetä viesti',
      submitting: 'Lähetetään...',
      successMessage: 'Kiitos! Viestisi on lähetetty.',
      errorMessage: 'Jotain meni pieleen. Yritä uudelleen.',
      inquiryTypes: {
        aiLanding: 'AI-laskeutumissivu',
        aiFullstack: 'AI-verkkosivuston rakentaminen (Fullstack-sovellus)',
        businessProcess: 'Liiketoimintaprosessianalyysi',
        businessDev: 'Liiketoiminnan kehityspyyntö',
        customSaas: 'Räätälöidyt SaaS-ratkaisut',
        general: 'Yleinen pyyntö / Tarjous',
        salesLeads: 'SaaS Sales Leads Pro Tarjous'
      }
    },
    footer: {
      tagline: 'Logardt Group KB',
      description: 'Toimittaa AI-ohjattuja digitaalisia ratkaisuja, jotka skaalaa liiketoimintaasi.',
      servicesTitle: 'Palvelut',
      companyTitle: 'Yritys',
      legalTitle: 'Lakiasiat',
      aboutUs: 'Tietoa meistä',
      portfolio: 'Portfolio',
      contact: 'Ota yhteyttä',
      terms: 'Käyttöehdot',
      privacy: 'Tietosuojakäytäntö',
      cookies: 'Evästekäytäntö',
      copyright: '© 2025 Logardt Group KB. Kaikki oikeudet pidätetään.',
      vatNumber: 'Y-tunnus',
      location: 'Täby, Ruotsi'
    }
  }
};

// Continue with other languages (Italian, French, German, Greek, Spanish)
// Due to length, I'll add them in a structured way

resources.it = {
  translation: {
    nav: {
      home: 'Home',
      aboutUs: 'Chi Siamo',
      services: 'Servizi',
      portfolio: 'Portfolio',
      salesLeadsPro: 'Sales Leads Pro',
      contact: 'Contatti'
    },
    hero: {
      tagline: 'per aziende ambiziose',
      title: 'Scala il tuo business.',
      titleLine2: 'Non i tuoi costi.',
      description: 'Da soluzioni SaaS basate su AI a siti web straordinari—forniamo prodotti digitali personalizzati che guidano la crescita, costruiti con tecnologia all\'avanguardia a una frazione dei costi tradizionali.',
      ctaExplore: 'Esplora Soluzioni SaaS',
      ctaServices: 'Vedi Tutti i Servizi',
      badge1: 'Soluzioni AI',
      badge2: 'Sviluppo Personalizzato',
      badge3: 'Servizi Globali'
    },
    stats: {
      label1: 'Eccellenza professionale',
      label2: 'Portfolio in crescita',
      mba: 'MBA',
      mbaLabel: 'in Sviluppo Business',
      successRate: '100%',
      successLabel: 'Tasso di Successo',
      delivery: '2 settimane',
      deliveryLabel: 'Tempo Medio di Consegna'
    },
    services: {
      tagline: 'cosa offriamo',
      title: 'I Nostri Servizi',
      description: 'Soluzioni digitali complete su misura per le tue esigenze aziendali',
      aiWebsite: 'Creazione Siti Web AI',
      aiWebsiteDesc: 'Landing page professionali e applicazioni fullstack costruite con Emergent AI—qualità da agenzia a una frazione del costo.',
      feature1: 'Landing Page da €350',
      feature2: 'App Fullstack da €950',
      feature3: '2 Round di Revisioni',
      imageTitle: 'Costruito con Tecnologia Moderna',
      imageDesc: 'Ogni sito web è realizzato utilizzando tecnologia AI all\'avanguardia e le migliori pratiche per prestazioni, sicurezza e scalabilità.',
      process: 'Analisi Processi Aziendali',
      processDesc: 'Analisi approfondita delle tue operazioni per identificare inefficienze e opportunità di automazione e miglioramento.',
      saas: 'Soluzioni SaaS Personalizzate',
      saasDesc: 'Piattaforme software-as-a-service su misura progettate specificamente per il tuo modello di business e le esigenze dei clienti.'
    },
    portfolio: {
      tagline: 'il nostro lavoro',
      title: 'Portfolio',
      description: 'Mostriamo i nostri recenti progetti di siti web basati su AI',
      viewLive: 'Visualizza Sito Live',
      case1Title: 'App Fullstack per Riconciliazione Finanziaria',
      case2Title: 'App Fullstack per Sistema di Gestione Qualità',
      case3Title: 'Landing Page per Logardt Ekonomiresurs',
      case4Title: 'Landing Page per Redoc AML & KYC',
      case5Title: 'Landing Page per Piattaforma Amministrazione Orchestra',
      case6Title: 'App Fullstack per Piattaforma Affitti Vacanze',
      case7Title: 'Landing Page per Sito Autore'
    },
    howItWorks: {
      tagline: 'il nostro processo',
      title: 'Come lavoriamo con te.',
      step1Num: '01',
      step1Title: 'Scoperta & Pianificazione',
      step1Desc: 'Comprendiamo il tuo business, obiettivi e requisiti. Definiamo ambito, tempistiche e deliverable.',
      step2Num: '02',
      step2Title: 'Design & Sviluppo',
      step2Desc: 'Il nostro team costruisce la tua soluzione usando gli ultimi strumenti AI e di sviluppo. Aggiornamenti regolari e cicli di feedback.',
      step3Num: '03',
      step3Title: 'Lancio & Supporto',
      step3Desc: 'Implementiamo il tuo progetto con test completi. Supporto continuo e iterazioni basate sulle tue esigenze.'
    },
    contact: {
      tagline: 'contattaci',
      title: 'Costruiamo qualcosa di grande insieme',
      description: 'Hai un progetto in mente? Ci piacerebbe sentirne parlare. Inviaci un messaggio e ti risponderemo il prima possibile.',
      nameLabel: 'Il Tuo Nome',
      namePlaceholder: 'Mario Rossi',
      emailLabel: 'Indirizzo Email',
      emailPlaceholder: 'mario@esempio.it',
      inquiryLabel: 'Tipo di Richiesta',
      messageLabel: 'Il Tuo Messaggio',
      messagePlaceholder: 'Parlaci del tuo progetto...',
      submitButton: 'Invia Messaggio',
      submitting: 'Invio...',
      successMessage: 'Grazie! Il tuo messaggio è stato inviato.',
      errorMessage: 'Qualcosa è andato storto. Riprova.',
      inquiryTypes: {
        aiLanding: 'Landing Page AI',
        aiFullstack: 'Creazione Siti Web AI (App Fullstack)',
        businessProcess: 'Analisi Processi Aziendali',
        businessDev: 'Richiesta Sviluppo Business',
        customSaas: 'Soluzioni SaaS Personalizzate',
        general: 'Richiesta Generale / Preventivo',
        salesLeads: 'Preventivo SaaS Sales Leads Pro'
      }
    },
    footer: {
      tagline: 'Logardt Group KB',
      description: 'Forniamo soluzioni digitali basate su AI che scalano il tuo business.',
      servicesTitle: 'Servizi',
      companyTitle: 'Azienda',
      legalTitle: 'Legale',
      aboutUs: 'Chi siamo',
      portfolio: 'Portfolio',
      contact: 'Contatti',
      terms: 'Termini di Servizio',
      privacy: 'Informativa Privacy',
      cookies: 'Politica Cookie',
      copyright: '© 2025 Logardt Group KB. Tutti i diritti riservati.',
      vatNumber: 'P.IVA',
      location: 'Täby, Svezia'
    }
  }
};

resources.fr = {
  translation: {
    nav: {
      home: 'Accueil',
      aboutUs: 'À Propos',
      services: 'Services',
      portfolio: 'Portfolio',
      salesLeadsPro: 'Sales Leads Pro',
      contact: 'Contact'
    },
    hero: {
      tagline: 'pour entreprises ambitieuses',
      title: 'Faites évoluer votre entreprise.',
      titleLine2: 'Pas vos coûts.',
      description: 'Des solutions SaaS basées sur l\'IA aux sites web époustouflants—nous livrons des produits numériques personnalisés qui stimulent la croissance, construits avec une technologie de pointe à une fraction des coûts traditionnels.',
      ctaExplore: 'Explorer Solutions SaaS',
      ctaServices: 'Voir Tous les Services',
      badge1: 'Solutions IA',
      badge2: 'Développement Personnalisé',
      badge3: 'Services Mondiaux'
    },
    stats: {
      label1: 'Excellence professionnelle',
      label2: 'Portfolio en croissance',
      mba: 'MBA',
      mbaLabel: 'en Développement Commercial',
      successRate: '100%',
      successLabel: 'Taux de Satisfaction',
      delivery: '2 semaines',
      deliveryLabel: 'Délai Moyen de Livraison'
    },
    services: {
      tagline: 'ce que nous offrons',
      title: 'Nos Services',
      description: 'Solutions numériques complètes adaptées à vos besoins professionnels',
      aiWebsite: 'Création de Sites Web IA',
      aiWebsiteDesc: 'Pages de destination professionnelles et applications fullstack construites avec Emergent AI—qualité d\'agence à une fraction du coût.',
      feature1: 'Pages de Destination à partir de 350€',
      feature2: 'Applications Fullstack à partir de 950€',
      feature3: '2 Tours de Révisions',
      imageTitle: 'Construit avec Technologie Moderne',
      imageDesc: 'Chaque site web est conçu avec une technologie IA de pointe et les meilleures pratiques en matière de performance, sécurité et évolutivité.',
      process: 'Analyse des Processus Métier',
      processDesc: 'Analyse approfondie de vos opérations pour identifier les inefficacités et les opportunités d\'automatisation et d\'amélioration.',
      saas: 'Solutions SaaS Personnalisées',
      saasDesc: 'Plateformes software-as-a-service sur mesure conçues spécifiquement pour votre modèle commercial et les besoins de vos clients.'
    },
    portfolio: {
      tagline: 'notre travail',
      title: 'Portfolio',
      description: 'Présentation de nos récents projets de sites web basés sur l\'IA',
      viewLive: 'Voir Site en Direct',
      case1Title: 'Application Fullstack pour Réconciliation Financière',
      case2Title: 'Application Fullstack pour Système de Gestion de la Qualité',
      case3Title: 'Page de Destination pour Logardt Ekonomiresurs',
      case4Title: 'Page de Destination pour Redoc AML & KYC',
      case5Title: 'Page de Destination pour Plateforme d\'Administration d\'Orchestre',
      case6Title: 'Application Fullstack pour Plateforme de Location de Vacances',
      case7Title: 'Page de Destination pour Site d\'Auteur'
    },
    howItWorks: {
      tagline: 'notre processus',
      title: 'Comment nous travaillons avec vous.',
      step1Num: '01',
      step1Title: 'Découverte & Planification',
      step1Desc: 'Nous comprenons votre entreprise, vos objectifs et vos exigences. Définir la portée, le calendrier et les livrables.',
      step2Num: '02',
      step2Title: 'Conception & Développement',
      step2Desc: 'Notre équipe construit votre solution en utilisant les derniers outils d\'IA et de développement. Mises à jour régulières et boucles de feedback.',
      step3Num: '03',
      step3Title: 'Lancement & Support',
      step3Desc: 'Déployer votre projet avec des tests complets. Support continu et itérations basées sur vos besoins.'
    },
    contact: {
      tagline: 'contactez-nous',
      title: 'Construisons quelque chose de grand ensemble',
      description: 'Vous avez un projet en tête? Nous aimerions en entendre parler. Envoyez-nous un message et nous vous répondrons dès que possible.',
      nameLabel: 'Votre Nom',
      namePlaceholder: 'Jean Dupont',
      emailLabel: 'Adresse Email',
      emailPlaceholder: 'jean@exemple.fr',
      inquiryLabel: 'Type de Demande',
      messageLabel: 'Votre Message',
      messagePlaceholder: 'Parlez-nous de votre projet...',
      submitButton: 'Envoyer Message',
      submitting: 'Envoi...',
      successMessage: 'Merci! Votre message a été envoyé.',
      errorMessage: 'Une erreur est survenue. Veuillez réessayer.',
      inquiryTypes: {
        aiLanding: 'Page de Destination IA',
        aiFullstack: 'Création de Sites Web IA (Application Fullstack)',
        businessProcess: 'Analyse des Processus Métier',
        businessDev: 'Demande de Développement Commercial',
        customSaas: 'Solutions SaaS Personnalisées',
        general: 'Demande Générale / Devis',
        salesLeads: 'Devis SaaS Sales Leads Pro'
      }
    },
    footer: {
      tagline: 'Logardt Group KB',
      description: 'Livrons des solutions numériques basées sur l\'IA qui font évoluer votre entreprise.',
      servicesTitle: 'Services',
      companyTitle: 'Entreprise',
      legalTitle: 'Légal',
      aboutUs: 'À propos',
      portfolio: 'Portfolio',
      contact: 'Contact',
      terms: 'Conditions de Service',
      privacy: 'Politique de Confidentialité',
      cookies: 'Politique de Cookies',
      copyright: '© 2025 Logardt Group KB. Tous droits réservés.',
      vatNumber: 'N° TVA',
      location: 'Täby, Suède'
    }
  }
};

resources.de = {
  translation: {
    nav: {
      home: 'Startseite',
      aboutUs: 'Über Uns',
      services: 'Dienstleistungen',
      portfolio: 'Portfolio',
      salesLeadsPro: 'Sales Leads Pro',
      contact: 'Kontakt'
    },
    hero: {
      tagline: 'für ehrgeizige unternehmen',
      title: 'Skalieren Sie Ihr Geschäft.',
      titleLine2: 'Nicht Ihre Kosten.',
      description: 'Von KI-gestützten SaaS-Lösungen bis hin zu beeindruckenden Websites—wir liefern maßgeschneiderte digitale Produkte, die Wachstum fördern, gebaut mit modernster Technologie zu einem Bruchteil traditioneller Kosten.',
      ctaExplore: 'SaaS-Lösungen Erkunden',
      ctaServices: 'Alle Dienste Ansehen',
      badge1: 'KI-gestützte Lösungen',
      badge2: 'Individuelle Entwicklung',
      badge3: 'Globale Dienste'
    },
    stats: {
      label1: 'Professionelle Exzellenz',
      label2: 'Wachsendes Portfolio',
      mba: 'MBA',
      mbaLabel: 'in Geschäftsentwicklung',
      successRate: '100%',
      successLabel: 'Kundenzufriedenheit',
      delivery: '2 Wochen',
      deliveryLabel: 'Durchschn. Lieferzeit'
    },
    services: {
      tagline: 'was wir anbieten',
      title: 'Unsere Dienstleistungen',
      description: 'Umfassende digitale Lösungen, maßgeschneidert für Ihre Geschäftsanforderungen',
      aiWebsite: 'KI-Website-Entwicklung',
      aiWebsiteDesc: 'Professionelle Landingpages und Fullstack-Anwendungen, gebaut mit Emergent AI—Agenturqualität zu einem Bruchteil der Kosten.',
      feature1: 'Landingpages ab €350',
      feature2: 'Fullstack-Apps ab €950',
      feature3: '2 Überarbeitungsrunden',
      imageTitle: 'Mit moderner Technologie gebaut',
      imageDesc: 'Jede Website wird mit modernster KI-Technologie und Best Practices für Leistung, Sicherheit und Skalierbarkeit erstellt.',
      process: 'Geschäftsprozessanalyse',
      processDesc: 'Tiefgehende Analyse Ihrer Abläufe zur Identifizierung von Ineffizienzen und Möglichkeiten für Automatisierung und Verbesserung.',
      saas: 'Maßgeschneiderte SaaS-Lösungen',
      saasDesc: 'Maßgeschneiderte Software-as-a-Service-Plattformen, speziell für Ihr Geschäftsmodell und die Bedürfnisse Ihrer Kunden entwickelt.'
    },
    portfolio: {
      tagline: 'unsere arbeit',
      title: 'Portfolio',
      description: 'Präsentation unserer neuesten KI-gestützten Website-Projekte',
      viewLive: 'Live-Site Ansehen',
      case1Title: 'Fullstack-App für Finanzabstimmung',
      case2Title: 'Fullstack-App für Qualitätsmanagementsystem',
      case3Title: 'Landingpage für Logardt Ekonomiresurs',
      case4Title: 'Landingpage für Redoc AML & KYC',
      case5Title: 'Landingpage für Orchesterverwaltungsplattform',
      case6Title: 'Fullstack-App für Ferienvermietungsplattform',
      case7Title: 'Landingpage für Autoren-Website'
    },
    howItWorks: {
      tagline: 'unser arbeitsprozess',
      title: 'Wie wir mit Ihnen arbeiten.',
      step1Num: '01',
      step1Title: 'Entdeckung & Planung',
      step1Desc: 'Wir verstehen Ihr Geschäft, Ihre Ziele und Anforderungen. Umfang, Zeitplan und Ergebnisse definieren.',
      step2Num: '02',
      step2Title: 'Design & Entwicklung',
      step2Desc: 'Unser Team baut Ihre Lösung mit den neuesten KI- und Entwicklungstools. Regelmäßige Updates und Feedback-Schleifen.',
      step3Num: '03',
      step3Title: 'Start & Support',
      step3Desc: 'Stellen Sie Ihr Projekt mit vollständigen Tests bereit. Laufender Support und Iterationen basierend auf Ihren Bedürfnissen.'
    },
    contact: {
      tagline: 'kontakt',
      title: 'Lassen Sie uns gemeinsam etwas Großartiges schaffen',
      description: 'Haben Sie ein Projekt im Kopf? Wir würden gerne davon hören. Senden Sie uns eine Nachricht und wir melden uns so schnell wie möglich.',
      nameLabel: 'Ihr Name',
      namePlaceholder: 'Max Mustermann',
      emailLabel: 'E-Mail-Adresse',
      emailPlaceholder: 'max@beispiel.de',
      inquiryLabel: 'Anfrageart',
      messageLabel: 'Ihre Nachricht',
      messagePlaceholder: 'Erzählen Sie uns von Ihrem Projekt...',
      submitButton: 'Nachricht Senden',
      submitting: 'Wird gesendet...',
      successMessage: 'Danke! Ihre Nachricht wurde gesendet.',
      errorMessage: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.',
      inquiryTypes: {
        aiLanding: 'KI-Landingpage',
        aiFullstack: 'KI-Website-Entwicklung (Fullstack-App)',
        businessProcess: 'Geschäftsprozessanalyse',
        businessDev: 'Geschäftsentwicklungsanfrage',
        customSaas: 'Maßgeschneiderte SaaS-Lösungen',
        general: 'Allgemeine Anfrage / Angebot',
        salesLeads: 'SaaS Sales Leads Pro Angebot'
      }
    },
    footer: {
      tagline: 'Logardt Group KB',
      description: 'Liefern KI-gestützte digitale Lösungen, die Ihr Geschäft skalieren.',
      servicesTitle: 'Dienstleistungen',
      companyTitle: 'Unternehmen',
      legalTitle: 'Rechtliches',
      aboutUs: 'Über uns',
      portfolio: 'Portfolio',
      contact: 'Kontakt',
      terms: 'Nutzungsbedingungen',
      privacy: 'Datenschutzerklärung',
      cookies: 'Cookie-Richtlinie',
      copyright: '© 2025 Logardt Group KB. Alle Rechte vorbehalten.',
      vatNumber: 'USt-IdNr',
      location: 'Täby, Schweden'
    }
  }
};

resources.el = {
  translation: {
    nav: {
      home: 'Αρχική',
      aboutUs: 'Σχετικά',
      services: 'Υπηρεσίες',
      portfolio: 'Portfolio',
      salesLeadsPro: 'Sales Leads Pro',
      contact: 'Επικοινωνία'
    },
    hero: {
      tagline: 'για φιλόδοξες επιχειρήσεις',
      title: 'Κλιμακώστε την επιχείρησή σας.',
      titleLine2: 'Όχι τα κόστη σας.',
      description: 'Από λύσεις SaaS βασισμένες σε AI έως εντυπωσιακούς ιστότοπους—παραδίδουμε προσαρμοσμένα ψηφιακά προϊόντα που προωθούν την ανάπτυξη, κατασκευασμένα με τεχνολογία αιχμής σε ένα κλάσμα των παραδοσιακών κοστών.',
      ctaExplore: 'Εξερευνήστε Λύσεις SaaS',
      ctaServices: 'Δείτε Όλες τις Υπηρεσίες',
      badge1: 'Λύσεις AI',
      badge2: 'Προσαρμοσμένη Ανάπτυξη',
      badge3: 'Παγκόσμιες Υπηρεσίες'
    },
    stats: {
      label1: 'Επαγγελματική αριστεία',
      label2: 'Αναπτυσσόμενο portfolio',
      mba: 'MBA',
      mbaLabel: 'στην Ανάπτυξη Επιχειρήσεων',
      successRate: '100%',
      successLabel: 'Ποσοστό Ικανοποίησης',
      delivery: '2 εβδομάδες',
      deliveryLabel: 'Μέσος Χρόνος Παράδοσης'
    },
    services: {
      tagline: 'τι προσφέρουμε',
      title: 'Οι Υπηρεσίες Μας',
      description: 'Ολοκληρωμένες ψηφιακές λύσεις προσαρμοσμένες στις επιχειρηματικές σας ανάγκες',
      aiWebsite: 'Κατασκευή Ιστοσελίδων AI',
      aiWebsiteDesc: 'Επαγγελματικές σελίδες προορισμού και εφαρμογές fullstack κατασκευασμένες με Emergent AI—ποιότητα πρακτορείου σε ένα κλάσμα του κόστους.',
      feature1: 'Σελίδες Προορισμού από €350',
      feature2: 'Εφαρμογές Fullstack από €950',
      feature3: '2 Γύρους Αναθεωρήσεων',
      imageTitle: 'Κατασκευασμένο με Σύγχρονη Τεχνολογία',
      imageDesc: 'Κάθε ιστοσελίδα κατασκευάζεται με τεχνολογία AI αιχμής και βέλτιστες πρακτικές για απόδοση, ασφάλεια και επεκτασιμότητα.',
      process: 'Ανάλυση Επιχειρηματικών Διαδικασιών',
      processDesc: 'Εις βάθος ανάλυση των λειτουργιών σας για τον εντοπισμό αναποτελεσματικοτήτων και ευκαιριών για αυτοματοποίηση και βελτίωση.',
      saas: 'Προσαρμοσμένες Λύσεις SaaS',
      saasDesc: 'Εξατομικευμένες πλατφόρμες λογισμικού-ως-υπηρεσίας σχεδιασμένες ειδικά για το επιχειρηματικό σας μοντέλο και τις ανάγκες των πελατών σας.'
    },
    portfolio: {
      tagline: 'η δουλειά μας',
      title: 'Portfolio',
      description: 'Παρουσίαση των πρόσφατων έργων ιστοσελίδων μας βασισμένων σε AI',
      viewLive: 'Δείτε Ζωντανή Σελίδα',
      case1Title: 'Εφαρμογή Fullstack για Χρηματοοικονομική Συμφωνία',
      case2Title: 'Εφαρμογή Fullstack για Σύστημα Διαχείρισης Ποιότητας',
      case3Title: 'Σελίδα Προορισμού για Logardt Ekonomiresurs',
      case4Title: 'Σελίδα Προορισμού για Redoc AML & KYC',
      case5Title: 'Σελίδα Προορισμού για Πλατφόρμα Διαχείρισης Ορχήστρας',
      case6Title: 'Εφαρμογή Fullstack για Πλατφόρμα Ενοικίασης Διακοπών',
      case7Title: 'Σελίδα Προορισμού για Ιστοσελίδα Συγγραφέα'
    },
    howItWorks: {
      tagline: 'η διαδικασία μας',
      title: 'Πώς δουλεύουμε μαζί σας.',
      step1Num: '01',
      step1Title: 'Ανακάλυψη & Σχεδιασμός',
      step1Desc: 'Κατανοούμε την επιχείρησή σας, τους στόχους και τις απαιτήσεις σας. Ορίζουμε το πεδίο, το χρονοδιάγραμμα και τα παραδοτέα.',
      step2Num: '02',
      step2Title: 'Σχεδιασμός & Ανάπτυξη',
      step2Desc: 'Η ομάδα μας κατασκευάζει τη λύση σας χρησιμοποιώντας τα πιο πρόσφατα εργαλεία AI και ανάπτυξης. Τακτικές ενημερώσεις και βρόχοι ανατροφοδότησης.',
      step3Num: '03',
      step3Title: 'Εκκίνηση & Υποστήριξη',
      step3Desc: 'Αναπτύξτε το έργο σας με πλήρη δοκιμή. Συνεχής υποστήριξη και επαναλήψεις βάσει των αναγκών σας.'
    },
    contact: {
      tagline: 'επικοινωνήστε',
      title: 'Ας φτιάξουμε κάτι υπέροχο μαζί',
      description: 'Έχετε ένα έργο στο μυαλό σας; Θα θέλαμε να ακούσουμε γι\' αυτό. Στείλτε μας ένα μήνυμα και θα επικοινωνήσουμε το συντομότερο δυνατό.',
      nameLabel: 'Το Όνομά Σας',
      namePlaceholder: 'Γιάννης Παπαδόπουλος',
      emailLabel: 'Διεύθυνση Email',
      emailPlaceholder: 'giannis@paradeigma.gr',
      inquiryLabel: 'Τύπος Ερωτήματος',
      messageLabel: 'Το Μήνυμά Σας',
      messagePlaceholder: 'Πείτε μας για το έργο σας...',
      submitButton: 'Αποστολή Μηνύματος',
      submitting: 'Αποστολή...',
      successMessage: 'Ευχαριστούμε! Το μήνυμά σας στάλθηκε.',
      errorMessage: 'Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά.',
      inquiryTypes: {
        aiLanding: 'Σελίδα Προορισμού AI',
        aiFullstack: 'Κατασκευή Ιστοσελίδων AI (Εφαρμογή Fullstack)',
        businessProcess: 'Ανάλυση Επιχειρηματικών Διαδικασιών',
        businessDev: 'Αίτημα Ανάπτυξης Επιχειρήσεων',
        customSaas: 'Προσαρμοσμένες Λύσεις SaaS',
        general: 'Γενικό Αίτημα / Προσφορά',
        salesLeads: 'Προσφορά SaaS Sales Leads Pro'
      }
    },
    footer: {
      tagline: 'Logardt Group KB',
      description: 'Παραδίδουμε ψηφιακές λύσεις βασισμένες σε AI που κλιμακώνουν την επιχείρησή σας.',
      servicesTitle: 'Υπηρεσίες',
      companyTitle: 'Εταιρεία',
      legalTitle: 'Νομικά',
      aboutUs: 'Σχετικά',
      portfolio: 'Portfolio',
      contact: 'Επικοινωνία',
      terms: 'Όροι Υπηρεσίας',
      privacy: 'Πολιτική Απορρήτου',
      cookies: 'Πολιτική Cookies',
      copyright: '© 2025 Logardt Group KB. Όλα τα δικαιώματα διατηρούνται.',
      vatNumber: 'ΑΦΜ',
      location: 'Täby, Σουηδία'
    }
  }
};

resources.es = {
  translation: {
    nav: {
      home: 'Inicio',
      aboutUs: 'Sobre Nosotros',
      services: 'Servicios',
      portfolio: 'Portfolio',
      salesLeadsPro: 'Sales Leads Pro',
      contact: 'Contacto'
    },
    hero: {
      tagline: 'para empresas ambiciosas',
      title: 'Escala tu negocio.',
      titleLine2: 'No tus costos.',
      description: 'Desde soluciones SaaS impulsadas por IA hasta sitios web impresionantes—entregamos productos digitales personalizados que impulsan el crecimiento, construidos con tecnología de vanguardia a una fracción de los costos tradicionales.',
      ctaExplore: 'Explorar Soluciones SaaS',
      ctaServices: 'Ver Todos los Servicios',
      badge1: 'Soluciones IA',
      badge2: 'Desarrollo Personalizado',
      badge3: 'Servicios Globales'
    },
    stats: {
      label1: 'Excelencia profesional',
      label2: 'Portfolio en crecimiento',
      mba: 'MBA',
      mbaLabel: 'en Desarrollo de Negocios',
      successRate: '100%',
      successLabel: 'Tasa de Satisfacción',
      delivery: '2 semanas',
      deliveryLabel: 'Tiempo Promedio de Entrega'
    },
    services: {
      tagline: 'lo que ofrecemos',
      title: 'Nuestros Servicios',
      description: 'Soluciones digitales integrales adaptadas a tus necesidades empresariales',
      aiWebsite: 'Creación de Sitios Web IA',
      aiWebsiteDesc: 'Páginas de destino profesionales y aplicaciones fullstack construidas con Emergent AI—calidad de agencia a una fracción del costo.',
      feature1: 'Páginas de Destino desde €350',
      feature2: 'Aplicaciones Fullstack desde €950',
      feature3: '2 Rondas de Revisiones',
      imageTitle: 'Construido con Tecnología Moderna',
      imageDesc: 'Cada sitio web se elabora con tecnología IA de vanguardia y mejores prácticas para rendimiento, seguridad y escalabilidad.',
      process: 'Análisis de Procesos Empresariales',
      processDesc: 'Análisis profundo de tus operaciones para identificar ineficiencias y oportunidades de automatización y mejora.',
      saas: 'Soluciones SaaS Personalizadas',
      saasDesc: 'Plataformas de software como servicio a medida diseñadas específicamente para tu modelo de negocio y las necesidades de tus clientes.'
    },
    portfolio: {
      tagline: 'nuestro trabajo',
      title: 'Portfolio',
      description: 'Mostrando nuestros recientes proyectos de sitios web impulsados por IA',
      viewLive: 'Ver Sitio en Vivo',
      case1Title: 'Aplicación Fullstack para Reconciliación Financiera',
      case2Title: 'Aplicación Fullstack para Sistema de Gestión de Calidad',
      case3Title: 'Página de Destino para Logardt Ekonomiresurs',
      case4Title: 'Página de Destino para Redoc AML & KYC',
      case5Title: 'Página de Destino para Plataforma de Administración de Orquesta',
      case6Title: 'Aplicación Fullstack para Plataforma de Alquiler Vacacional',
      case7Title: 'Página de Destino para Sitio de Autor'
    },
    howItWorks: {
      tagline: 'nuestro proceso',
      title: 'Cómo trabajamos contigo.',
      step1Num: '01',
      step1Title: 'Descubrimiento & Planificación',
      step1Desc: 'Entendemos tu negocio, objetivos y requisitos. Definimos alcance, cronograma y entregables.',
      step2Num: '02',
      step2Title: 'Diseño & Desarrollo',
      step2Desc: 'Nuestro equipo construye tu solución usando las últimas herramientas de IA y desarrollo. Actualizaciones regulares y bucles de retroalimentación.',
      step3Num: '03',
      step3Title: 'Lanzamiento & Soporte',
      step3Desc: 'Implementa tu proyecto con pruebas completas. Soporte continuo e iteraciones basadas en tus necesidades.'
    },
    contact: {
      tagline: 'contáctanos',
      title: 'Construyamos algo grandioso juntos',
      description: '¿Tienes un proyecto en mente? Nos encantaría saber de él. Envíanos un mensaje y te responderemos lo antes posible.',
      nameLabel: 'Tu Nombre',
      namePlaceholder: 'Juan Pérez',
      emailLabel: 'Dirección de Email',
      emailPlaceholder: 'juan@ejemplo.es',
      inquiryLabel: 'Tipo de Consulta',
      messageLabel: 'Tu Mensaje',
      messagePlaceholder: 'Cuéntanos sobre tu proyecto...',
      submitButton: 'Enviar Mensaje',
      submitting: 'Enviando...',
      successMessage: '¡Gracias! Tu mensaje ha sido enviado.',
      errorMessage: 'Algo salió mal. Por favor intenta de nuevo.',
      inquiryTypes: {
        aiLanding: 'Página de Destino IA',
        aiFullstack: 'Creación de Sitios Web IA (Aplicación Fullstack)',
        businessProcess: 'Análisis de Procesos Empresariales',
        businessDev: 'Solicitud de Desarrollo Empresarial',
        customSaas: 'Soluciones SaaS Personalizadas',
        general: 'Consulta General / Cotización',
        salesLeads: 'Cotización SaaS Sales Leads Pro'
      }
    },
    footer: {
      tagline: 'Logardt Group KB',
      description: 'Entregando soluciones digitales impulsadas por IA que escalan tu negocio.',
      servicesTitle: 'Servicios',
      companyTitle: 'Empresa',
      legalTitle: 'Legal',
      aboutUs: 'Sobre nosotros',
      portfolio: 'Portfolio',
      contact: 'Contacto',
      terms: 'Términos de Servicio',
      privacy: 'Política de Privacidad',
      cookies: 'Política de Cookies',
      copyright: '© 2025 Logardt Group KB. Todos los derechos reservados.',
      vatNumber: 'NIF',
      location: 'Täby, Suecia'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
